import { Plus, FileText, ShoppingCart, Wrench, Truck, RotateCcw, Megaphone } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { HoverPopover } from "./HoverPopover";

const createItems = [
  { title: "New Claim", url: "/dealer-claims/new", icon: FileText, hint: "Warranty claim" },
  { title: "Quick Order", url: "/quick-order", icon: ShoppingCart, hint: "Add parts to cart" },
  { title: "New Ticket", url: "/case-management", icon: Wrench, hint: "Open a support case" },
  { title: "Register Unit", url: "/warranty-registration", icon: Truck, hint: "Register an RV" },
  { title: "New RGA", url: "/rga-list", icon: RotateCcw, hint: "Return goods authorization" },
  { title: "Post Announcement", url: "/message-board", icon: Megaphone, hint: "Dealer news" },
];

export function GlobalCreateMenu() {
  return (
    <HoverPopover
      contentClassName="w-72 p-0 border-0 outline-none ring-0"
      trigger={
        <Button size="sm" className="gap-1.5 font-medium shadow-sm">
          <Plus className="h-4 w-4" />
          <span className="hidden sm:inline">Create</span>
        </Button>
      }
    >
      <div className="py-2">
        <div className="px-4 pb-2 pt-1 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          Create new
        </div>
        {createItems.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.title}
              to={item.url}
              className="flex items-start gap-3 px-4 py-2.5 hover:bg-accent transition-colors group"
            >
              <Icon className="h-4 w-4 mt-0.5 text-muted-foreground group-hover:text-primary transition-colors" />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-foreground">{item.title}</div>
                <div className="text-xs text-muted-foreground">{item.hint}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </HoverPopover>
  );
}
